import { Injectable } from '@angular/core';

@Injectable()
export class LoginControl {
    
    private nameParam: string = 'loginParam';
    private dateParam : string = 'dateParam';

    constructor() { }

    clearAll()
    {
        this.deleteDate();
        this.removeUser();
    }

    setUser(user : object) {
        localStorage.setItem(this.nameParam, JSON.stringify(user));
    }

    getDate()
    {  
        if (localStorage.getItem(this.dateParam) != "" && localStorage.getItem(this.dateParam) != null) {
            return localStorage.getItem(this.dateParam);
        }else{
            return null;
        }
    }
    
    setDate(value : string)
    {
        localStorage.setItem(this.dateParam,value);
    }

    deleteDate()
    {
        localStorage.removeItem(this.dateParam);
    }

    removeUser() {
        localStorage.removeItem(this.nameParam);
    }

    userLogged() {
        if (localStorage.getItem(this.nameParam) != "" && localStorage.getItem(this.nameParam) != null) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Returna o usuário logado
     * @returns any
     */
    getUser() {
        if (this.userLogged()) {
            return JSON.parse(localStorage.getItem(this.nameParam));
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/providers/helpers/login.ts